module.exports = __webpack_public_path__ + "img/blog.22c5867.png";